export default __webpack_public_path__ + "static/media/bg4.7f86d0b6.webp";